import angular from 'angular';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { sanitize } from '@/shared/utils/htmlHelpers';

angular.module('cxRegistrations').directive('cxResourceTypeahead', [
  '$parse',
  'resourceNameFilter',
  function($parse, resourceNameFilter) {
    return {
      restrict: 'E',
      replace: true,
      template: `<div>
      <span data-translate="No pricelist items found. Please add an item using the pricelist" ng-show="!options.length"></span>
      <div class="dropdown dropdown-full-width" uib-dropdown ng-show="options.length" is-open="ddwOpen">
          <div class="input-group input-group-sm scrollable-typeahead {{iClass}}">
            <input type="text"
                   ng-disabled="disabled"
                   ng-model="selected"
                   uib-typeahead="item as item.label for item in options | regResourceSearch:{searchValue:($viewValue||''), crmType:crmType, assignmentTemplateId:assignmentTemplateId}:selected | limitTo:limit "
                   typeahead-min-length="0"
                   typeahead-select-on-blur="false"
                   typeahead-select-on-exact="true"
                   typeahead-on-select="onSelect($item, $event)"
                   typeahead-template-url="resourceTypeaheadTemplate.html"
                   ng-blur="onBlur()"
                   ng-keydown="onKeyDown($event)"
                   ng-focus="ddwOpen=false"
                   class="form-control"
                   autocomplete="off"
            />
            <span class="input-group-btn" >
              <button id="taskDropdownToggle" class="btn btn-default dropdown-toggle btn-font-14" ng-disabled="disabled || !options.length" uib-dropdown-toggle>
                <span class="caret"></span>
              </button>
            </span>
          </div>
          <ul class="dropdown-menu" role="menu" style="max-height:300px;overflow-y:auto;">
            <li ng-repeat="op in options | regResourceSearch:{searchValue:($viewValue||''), crmType:crmType, assignmentTemplateId:assignmentTemplateId}:selected" ng-class="{'selected':op===selected}">
              <a href ng-click="onSelect(op)">
                <div ng-class="{'margin-10L':op.level===0}">{{op.label}}</div>
              </a>
            </li>
          </ul>
          <script type="text/ng-template" id="resourceTypeaheadTemplate.html">
          <a>
            <div ng-if="match.model.level===1 && (index===0 || $parent.$parent.matches[index - 1].model.categoryId !== match.model.categoryId)" ng-bind-html="match.model.categoryLabel | uibTypeaheadHighlight:query" class="margin-10L"></div>
            <div ng-bind-html="match.label | sanitize | uibTypeaheadHighlight:query"  ng-class="{'margin-10L':match.model.level===0}"></div>
          </a>
          </script>
        </div>
      </div>
      `,
      require: 'ngModel',
      scope: {
        orgOptions: '=options',
        disabled: '=?ngDisabled',
        placeholder: '@?',
        iClass: '@?',
        crmType: '=?',
        assignmentTemplateId: '=?',
        autoSelect: '@?',
      },
      link: function(scope, el, attrs, ngModel) {
        if (!ngModel) return;
        scope.limit = attrs.limit || 9999;

        scope.view2model = function(value) {
          ngModel.$setViewValue(value);
        };

        function findSelected(value) {
          return value == null || !scope.options.length
            ? null
            : scope.options.find(function(el) {
                //Match by id
                if (
                  typeof el === 'object' &&
                  typeof value === 'object' &&
                  typeof el.id === 'string' &&
                  typeof value.id === 'string'
                )
                  return angular.equals(el.id, value.id);
                return angular.equals(el, value);
              });
        }

        // when angular detects a change to the model,
        // we update our inner value
        ngModel.$render = function() {
          scope.value = ngModel.$viewValue;
          scope.selected = findSelected(scope.value) || scope.value;
        };

        var getLabel = function(item) {
          if (!item) return null;
          return item.label;
        };

        scope.onSelect = function(i, event) {
          scope.selected = i;
          scope.value = i;
          scope.view2model(scope.value);
        };
        scope.crmTypeFilter = function(e) {
          if (typeof scope.crmType === 'undefined' || scope.crmType === null) return true;
          if (scope.selected === e) return true; //Allow if set externally (tasks, existing reg)
          //Crm type enabled
          if (scope.crmType === 0 && e.crmOthers) return true;
          if (scope.crmType === 2 && e.crmProspects) return true;
          if (scope.crmType === 3 && e.crmCustomers) return true;
          if (scope.crmType === 4 && e.crmOwnCompanies) return true;
          //None selected = All selected
          return !e.crmOthers && !e.crmProspects && !e.crmCustomers && !e.crmOwnCompanies;
        };
        function mapOptions() {
          if (!scope.orgOptions || !angular.isArray(scope.orgOptions)) {
            scope.options = [];
          } else {
            scope.options = scope.orgOptions
              .filter(x => x.isDefault && x.categoryId)
              .reduce((array, category) => {
                const categoryLabel = resourceNameFilter(category, false, false);
                const subResources = scope.orgOptions
                  .filter(x => !x.isDefault && x.categoryId && x.categoryId === category.categoryId)
                  .map(resource => {
                    const label = resourceNameFilter(resource, false, true);
                    return {
                      ...resource,
                      label: label,
                      categoryLabel,
                      search: `${categoryLabel};${label}`,
                      level: 1,
                    };
                  });
                //const subResourcesLabels = subResources.map(x => x.label).join(';');
                return array.concat([
                  {
                    ...category,
                    label: categoryLabel,
                    categoryLabel,
                    search: categoryLabel,
                    level: 0,
                  },
                  ...subResources,
                ]);
              }, [])
              .sort(dynamicSort('categoryLabel', 'isDefault', 'label'));
          }
          scope.selected = findSelected(scope.value) || scope.value;
        }
        mapOptions();
        scope.$watchCollection('orgOptions', function(newValue, oldValue) {
          mapOptions();
          if (scope.autoSelect == 'true' && scope.options.length === 1 && !scope.selected)
            scope.onSelect(scope.options[0]);
        });

        //Clear textbox if value is not in option list
        scope.onBlur = function() {
          if (scope.selected == null) return;
          if (typeof scope.selected === 'string') {
            scope.onSelect(null);
            return;
          }
          if (scope.options.indexOf(scope.selected) < 0) scope.onSelect(null);
        };
      },
    };
  },
]);
